import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils/typings';

const { name, version } = __serviceInfo__;

const serviceNames = {
    accountAccessViewController: 'ACCOUNT_ACCESS_PAGE_VIEW_CONTROLLER',
    dynamicFormViewController: 'DYNAMIC_FORM_VIEW_CONTROLLER',
    accountSignInFormViewController: 'ACCOUNT_SIGN_IN_FORM_VIEW_CONTROLLER',
    apiDataMapper: 'API_DATA_MAPPER',
    apiDropDownRepository: 'API_DROPDOWN_REPOSITORY',
    apiDropDownViewController: 'API_DROPDOWN_VIEW_CONTROLLER',
    configRepository: 'CONFIG_REPOSITORY',
    consentFormViewController: 'CONSENT_FORM_VIEW_CONTROLLER',
    dropdownDataStore: 'DROPDOWN_DATA_STORE',
    dropDownViewController: 'DROP_DOWN_VIEW_CONTROLLER',
    guestCheckoutFormViewController: 'GUEST_CHECKOUT_VIEW_CONTROLLER',
    httpTransport: 'HTTP_TRANSPORT',
    loginViewController: 'LOGIN_IN_VIEW_CONTROLLER',
    passwordCriteriaViewController: 'PASSWORD_CRITERIA_VIEW_CONTROLLER',
    passwordRepository: 'PASSWORD_REPOSITORY',
    passwordEntity: 'PASSWORD_ENTITY',
    passwordStrengthViewController: 'PASSWORD_STRENGTH_VIEW_CONTROLLER',
    passwordViewController: 'PASSWORD_VIEW_CONTROLLER',
    qrCodeViewController: 'QR_CODE_VIEW_CONTROLLER',
    rampMainViewController: 'RAMP_MAIN_VIEW_CONTROLLER',
    rampPgApiSdk: ' RAMP_PG_API_SDK',
    rampService: 'RAMP_SERVICE',
    rampSignInSignUpViewController: 'RAMP_SIGN_IN_SIGN_UP_VIEW_CONTROLLER',
    rampViewController: 'RAMP_VIEW_CONTROLLER',
    redirectViewController: 'REDIRECT_VIEW_CONTROLLER',
    routerStore: 'ROUTER_STORE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    signUpViewController: 'SIGN_UP_VIEW_CONTROLLER',
    socialButtonViewController: 'SOCIAL_BUTTON_VIEW_CONTROLLER',
    translationRepository: 'TRANSLATION_REPOSITORY',
    userFormViewController: 'USER_FORM',
    userRepository: 'USER_REPOSITORY',
    userSessionSuspenseViewController: 'USER_SESSION_SUSPENSE_VIEW_CONTROLLER',
    otpSmsViewController: 'OTP_SMS_VIEW_CONTROLLER',
    otpEmailViewController: 'OTP_EMAIL_VIEW_CONTROLLER',
    otpStateHelper: 'OTP_STATE_HELPER',
    messageRepository: 'MESSAGE_REPOSITORY',
    emailFormViewController: 'EMAIL_FORM_VIEW_CONTROLLER',
    resetPasswordFormViewController: 'RESET_PASSWORD_FORM_VIEW_CONTROLLER',
    registerSuccessViewController: 'REGISTER_SUCCESS_VIEW_CONTROLLER',
    languageSwitcherController: 'LANGUAGE_SWITCHER_CONTROLLER'
};

export default serviceNames;

export class RampService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}
